import * as React from 'react';

import { Promo } from './Promo';
import { INewbuildingPromo } from '../../types/newbuilding';
import { Container } from '../Container';

import * as styles from './PromoBlock.css';

export interface IPromoBlockProps {
  promos: INewbuildingPromo[];
  url: string;
  dataMark?: string;
}

export interface IPromoBlockState {
  currentPopUpIdx: number;
}

export class PromoBlock extends React.PureComponent<IPromoBlockProps, IPromoBlockState> {
  public state = {
    currentPopUpIdx: 0,
  };

  private setPopUp = (idx: number) => {
    this.setState((state) => state.currentPopUpIdx !== idx ? { currentPopUpIdx: idx } : null);
  }

  public render() {
    const { currentPopUpIdx } = this.state;
    const { promos, dataMark, url } = this.props;

    return (
      <Container
        dataMark={dataMark || 'PromoBlock'}
        className={styles['promo-block']}
      >
        {promos.map((promo: INewbuildingPromo, idx: number) => {
          return <Promo
            {...promo}
            url={url}
            popUpIdx={idx}
            currentPopUpIdx={currentPopUpIdx}
            setPopUp={this.setPopUp}
          />;
        })}
      </Container>
    );
  }
}
